// angular import
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { CommonService } from './shared/common.service';
import * as CryptoJS from 'crypto-js';
import { AccountingPeriodService } from './modules/accounts/accounting-period/services/accounting-period.service';
import { FormControl, FormGroup } from '@angular/forms';
import { NullValidationHandler, OAuthService } from 'angular-oauth2-oidc';
import { AuthConfigService } from './Configuration/auth-config.service';
import { ConfigurationService } from './Configuration/configuration.service';
import { CompanyServiceService } from './modules/company/companylist/company-service.service';
import { GlobalLogoutService } from './shared/andicaCentralServices/global-logout.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  // public props
  title = 'datta-able';
  apPeriodId: any;
  time: FormGroup;
  // constructor
  constructor(private router: Router, private commonService: CommonService, private globalLogoutService: GlobalLogoutService, private routing: ActivatedRoute, private oauthService: OAuthService, private authService: AuthConfigService, private configService: ConfigurationService, private companyService: CompanyServiceService) {
    this.time = new FormGroup({
      AdminLogout_time: new FormControl(''),
      AdminLogin_time: new FormControl(''),
      UserLoginID: new FormControl(''),
      Flag: new FormControl(''),
      UserLoginHistoryID: new FormControl('')
    })
    this.globalLogoutService.startWatching();
    this.configure();
    this.oauthService.tryLoginCodeFlow()
    this.oauthService.setupAutomaticSilentRefresh();
  }

  // life cycle event
  ngOnInit() {
    debugger
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    if (window.location.pathname != '/business' && window.location.pathname !='/fbireceipt') {
      this.commonService.headertags = true
      this.commonService.headertags1 = true
    }
    
    this.commonService.getCountry().subscribe((data: any) => {
      this.commonService.countryData = data.filter(x => x.CountryName == 'Scotland' || x.CountryName == 'Wales' || x.CountryName == 'United Kingdom');
    });

    this.commonService.getLegalformCompanies().subscribe((data: any) => {
      this.commonService.companyLegalformdata = data;
    })
    if (localStorage.getItem("APPeriodId"))
    var apPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    //var companyid = CryptoJS.AES.decrypt(localStorage.getItem("companyId"), "APS").toString(CryptoJS.enc.Utf8)
    if (apPeriodId) {
      this.commonService.getBasicInfo(apPeriodId);
      //this.commonService.getIncomeStatementsHeaders();
    }
    //this.commonService.showBubbledata(this.commonService.AccountTemplateId, companyid, apPeriodId);

    if (window.location.pathname != '/accountingperiod' && window.location.pathname != '/business' && window.location.pathname != '/pageselection') {
      if (localStorage.getItem("ImportEnable") == "true") {
        this.commonService.IsImportEnable(true)
      }
      this.commonService.Isnavdata(2);
      this.commonService.setOpenAccountingPeriod(true)
    }
    //if (window.location.pathname != '/accountingperiod' && window.location.pathname != '/companylist') {
    //  this.commonService.IsImportEnable(true)
    //}
   
  }
  public get claims() {
    let claims = this.oauthService.getIdentityClaims();
    return claims;

  }

  private configure() {
    debugger
    const isProductLogedOut = sessionStorage['ProductLogedout'] == 'Yes';

    if (!location.href.includes('localhost') && !isProductLogedOut) {
      if (window.location.pathname.includes('andicacentral')) {
        sessionStorage.setItem('andicacentral', 'Yes')
        window.location.href = window.location.origin
      }

      if (sessionStorage['andicacentral'] != 'Yes') {
        window.location.href = this.configService.andicaCentralURL(); // Based on  Environment
      }
    }
    this.oauthService.configure(this.authService.get());
    this.oauthService.tokenValidationHandler = new NullValidationHandler();
    this.oauthService.loadDiscoveryDocument(this.configService.get().discoveryDocumentConfigUrl);
    if (isProductLogedOut) {
      sessionStorage.removeItem('andicacentral')
    }
  }

}
